module.exports = __webpack_public_path__ + "static/media/reicLoading.afcf9c79.gif";